module.exports = __webpack_public_path__ + "media/svg-new/log-out-5f627caf.svg";